import { eventQBus } from "../types/EventQBus";
import type { DresonRuleResolvedEvent } from "./FilterTypes";
import { LoadFilter } from "./LoadFilter";
import { TsBct } from "./TsBct";
import { addFeaturesToPageImpressionTracking } from "../tracking/FeatureTracking";
import { Filter } from "../filter/Filter";
import { addSanErrorToPageImpression, FILTER_FEATURES } from "../filter/FilterTracking";
import { FilterSection } from "../filter/FilterSection";
import { events } from "../events";
import { isActive } from "../toggle/Toggle";
import { createLog } from "../util/log";

const log = createLog("reload");

export function registerFilterReloading() {
  if (isActive("HEUREKA_2407_MIGRATE_TO_REPTILE_NEXUS")) {
    events.initDresonRuleResolvedBridge();
    events.onDresonRuleResolved((data) => {
      const currentRule = FilterSection.template()?.currentDresonRule;
      if (data && data.rule !== currentRule) {
        log.debug("filter section reload triggered", { from: currentRule, to: data.rule });
        events.filterSectionLoad({
          rule: data.rule,
          page: data.page,
          ssid: TsBct.sfid(),
          entryRule: data.entryRule,
        });
      } else {
        log.debug("no filter section reload", {
          reason: data ? "rule unchanged" : "no selection state",
          rule: data?.rule,
          currentRule,
        });
      }
    });
    events.onDresonRuleResolveAborted(() => {
      log.debug("dresonRule resolve aborted, marking filters as invalid");
      Filter.handleError();
      addSanErrorToPageImpression("filterlist_empty");
      addFeaturesToPageImpressionTracking(FILTER_FEATURES);
    });
  } else {
    eventQBus.on("ftfind.dresonRule.resolved", (data: DresonRuleResolvedEvent) => {
      if (data && data.rule !== FilterSection.template().currentDresonRule) {
        if (data.count === 0) {
          log.debug("no filter section reload, resolved rule has no products", data.rule);
          Filter.handleError();
          addSanErrorToPageImpression("filterlist_empty");
          addFeaturesToPageImpressionTracking(FILTER_FEATURES);
        } else {
          log.debug("filter section reload triggered (deprecated)", data.rule);
          events.filterSectionLoadDeprecated(data.rule, data.page, TsBct.sfid());
        }
      } else {
        log.debug("no filter section reload: rule unchanged", data?.rule);
      }
    });
  }

  eventQBus.on("ftfind.dresonRule.resolveAborted", Filter.handleError);

  events.onFilterSectionLoad(LoadFilter.onLoadFilters);
  events.onFilterSectionInitialLoaded(LoadFilter.onInitialLoadedFilters);
}
